export const YEARS = 'years';
export const CALENDAR = 'calendar';
export const HOURS = 'hours';
export const MINUTES = 'minutes';

export const DATE_TAB = [CALENDAR, YEARS];
export const TIME_TAB = [HOURS, MINUTES];

export const DATE_VIEW_INDEX = 0;
export const TIME_VIEW_INDEX = 1;
